import { useEffect, useRef } from 'react'

import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { FilterBar } from 'widgets/kyrgyzstan/filter-bar'
import { SearchResultList } from 'widgets/kyrgyzstan/search-result-list'

import { getChildrenSearchParamsFromStore } from 'entities/kyrgyzstan/lib'
import {
  kyrgyzstanDetailContextStore,
  kyrgyzstanSearchStore,
} from 'entities/kyrgyzstan/model'
import { KyrgyzstanSearchParamsHeader } from 'entities/kyrgyzstan/ui'

import { useInfiniteScroll } from 'shared/hooks/use-infinity-scroll'

import s from './styles.module.scss'

const KyrgyzstanSearchResultPage = observer(() => {
  const navigate = useNavigate()

  const {
    fetchRealtyList,
    loadMore,
    cancelActiveRequest,
    hasMore,
    isLoading,
    realtyList,
    error,
  } = kyrgyzstanSearchStore

  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    fetchRealtyList()

    return () => {
      cancelActiveRequest()
    }
  }, [cancelActiveRequest, fetchRealtyList])

  useInfiniteScroll({
    targetRef,
    canLoad: hasMore && !isLoading,
    onLoad: () => {
      loadMore()
    },
  })

  const handleGoBack = () => {
    navigate(RoutingPaths.kyrgyzstan.path())
  }

  const handleEditSearch = () => {
    navigate(RoutingPaths.kyrgyzstan.searchForm.path())
  }

  const handleCardClick = (id: string) => {
    const detailSearchParams = getChildrenSearchParamsFromStore(
      kyrgyzstanSearchStore,
    )

    kyrgyzstanDetailContextStore.setContext({
      parentId: id,
      detailSearchParams,
    })

    navigate(RoutingPaths.kyrgyzstan.detail.path(id))
  }

  return (
    <div className={s.container}>
      <KyrgyzstanSearchParamsHeader
        onGoBack={handleGoBack}
        onEditSearch={handleEditSearch}
      />

      <FilterBar />

      <div className={clsx('container', s.content)}>
        <SearchResultList
          data={realtyList}
          isLoading={isLoading}
          error={error}
          onCardClick={handleCardClick}
        />

        <div ref={targetRef} />
      </div>
    </div>
  )
})

export default KyrgyzstanSearchResultPage
